
var OpenCC = require("opencc-js");
let converter = OpenCC.Converter({
		from:'hk',
		to:'cn'
})

const minxin = {
  data() {
    return {
      options: JSON.parse(converter(JSON.stringify([
        // {
        //   value: 1,
        //   label: "选择题"
        // },
        // {
        //   value: 2,
        //   label: "问答题"
        // },
        {
          value: 3,
          label: "文本"
        },
        // {
        //   value: 4,
        //   label: "添加文档"
        // }
        {
          value: 5,
          label: "附件"
        },
        // {
        //   value: 6,
        //   label: "课程"
        // },
        {
          value: 7,
          label: "评分"
        },
        {
          value: 8,
          label: "日期"
        },
        {
          value: 9,
          label: "单选"
        },
        {
          value: 10,
          label: "多选"
        },
				{
					value:12,
					label:"扫一扫"
				},{
          value:13,
          label:"数字"
        },{
          value:14,
          label:"打卡"
        }
      ]))),
      optionsPin:JSON.parse(converter(JSON.stringify([
       {
          value: 6,
          label: "课程"
        },
        {
          value: 11,
          label: "课程2"
        },
      ]))),
      options2: JSON.parse(converter(JSON.stringify({
        1: "选择题",
        // 2: "问答题",
        3: "文本",
        4: "添加文档",
        5: "附件",
        6: "课程",
        7: "评分",
        8: "日期",
        9: "单选",
        10: "多选",
        11: "课程",
				12:"扫一扫",
        13:"数字",
        14:"打卡"
      }))),
      buttonOptions: JSON.parse(converter(JSON.stringify([
        { name: "分组", type: 1 },
        { name: "分页", type: 2 }
      ])))
    };
  },
  computed: {},
  mounted() {},
  activated() {},
  methods: {
    depthCopy(s) {
      return s ? JSON.parse(JSON.stringify(s)) : '';
    }
  }
};

export default minxin;



// WEBPACK FOOTER //
// ./src/components/pages/test/add/minxins/minxin.js